import { render, staticRenderFns } from "./SystemMailer.vue?vue&type=template&id=21995a36&"
import script from "./SystemMailer.vue?vue&type=script&lang=js&"
export * from "./SystemMailer.vue?vue&type=script&lang=js&"
import style0 from "./SystemMailer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports